import React from 'react';
import { connect } from 'react-redux';

import { signedInSelector } from 'shared/app/bundles/user';

import CardsCollectionCrate from '../cards-collection-crate';
import GuestCardHome from '../guest-card-home';

export const SvcCards = ({ signedIn }) => {
  return signedIn ? <CardsCollectionCrate /> : <GuestCardHome />;
};

const select = (state) => ({
  signedIn: signedInSelector(state),
});

export default connect(select)(SvcCards);
